import { render, staticRenderFns } from "./VettingSingle.vue?vue&type=template&id=6bb73518"
import script from "./VettingSingle.vue?vue&type=script&lang=js"
export * from "./VettingSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports